<div>

    <!-- ── Info ───────────────────────────────────────────────────────────── -->
    <app-alert-card
        class="totais-info"
        type="info"
        title="Totais da nota"
        icon="info">
        Esta aba define como o sistema calcula o total da nota. Os valores são calculados
        automaticamente a partir dos itens — você só precisa indicar regras especiais
        (descontar ICMS desonerado, somar PIS-ST etc.) e revisar as fórmulas quando necessário.
    </app-alert-card>

    <!-- ── Configurações avançadas ────────────────────────────────────────── -->
    <app-totais-configuracoes-avancadas-section
        [form]="totaisForm"
        [personalizadasCount]="personalizadasCount"
        [pisAtivo]="pisAtivoValue"
        [cofinsAtivo]="cofinsAtivoValue"
        [icmsOuSnAtivo]="icmsOuSnAtivoValue"
        [indicadoresComposicaoTotalItem]="indicadoresComposicaoTotalItem"
        [indicadoresDeducaoDesoneracao]="indicadoresDeducaoDesoneracaoIcms"
        [indicadoresComposicaoTotalPisSt]="indicadoresComposicaoTotalPisSt"
        [indicadoresComposicaoTotalCofinsSt]="indicadoresComposicaoTotalCofinsSt"
        [tiposOperacaoVeiculo]="tiposOperacaoVeiculo"
        [regimesEspeciaisIssqn]="regimesEspeciaisTributacaoIssqn"
        (personalizar)="abrirEditorFormulas()">
    </app-totais-configuracoes-avancadas-section>

    <!-- ── Retenções na fonte ─────────────────────────────────────────────── -->
    <app-totais-retencoes-fonte-section [form]="totaisForm" [tiposBaseCalculo]="tiposBaseCalculoRetencao"></app-totais-retencoes-fonte-section>

    <!-- ── ISSQN — Data de competência ────────────────────────────────────── -->
    <app-totais-issqn-competencia-section [form]="totaisForm"></app-totais-issqn-competencia-section>

</div>
